export default {
  'warehouses.scan.title': 'Scan to inbound warehoues',
  'warehouses.scan.tracking_no': 'Tracking No.',
  'warehouses.scan.message.tracking_no': 'Please Enter Tracking No.',
  'warehouses.scan.fail': 'Fail to scan package',
  'warehouses.scan.success': 'Scan package has been succesfully',
};
